import {useState,useEffect,useRef} from "react"
import useApi from "../hooks/useApi"
import useBoard from "../hooks/useBoard"
import useDialog from "../hooks/useDialog"
import useToast from "../hooks/useToast"
import useRefresh from "../hooks/useRefresh"
import Board from "../components/Board"
import BoardContent from "../components/BoardContent"
import BoardActions from "../components/BoardActions"
import ButtonAction from "../commons/ButtonAction"
import ButtonCircle from "../commons/ButtonCircle"
import ButtonCommand from "../commons/ButtonCommand"
import Textbox from "../commons/Textbox"
import Selector from "../commons/Selector"
import Divisor from "../commons/Divisor"

export default function ModelsGenerate({params}){

    const requestApi=useApi()
    const [ready,setReady]=useState(1)
    const {changeDialog}=useDialog()
    const {changeToast}=useToast()
    const {loadBoard}=useBoard()
    const {refresh}=useRefresh()
    const mode=params.mode
    const [idVal,setIdVal]=useState(0)
    const [defaultData,setDefaultData]=useState("")
    const nameInput=useRef()
    const [nameVal,setNameVal]=useState("")
    const modelInput=useRef()
    const [modelVal,setModelVal]=useState("")
    const [modelOptions,setModelOptions]=useState([])
    const collectionInput=useRef()
    const [collectionVal,setCollectionVal]=useState("")
    const [collectionOptions,setCollectionOptions]=useState([])

    const loadModels=()=>{
        return new Promise(function(resolve){
            resolve(
                requestApi("models/list",{})
                    .then(data=>{
                        let newOptions=[]
                        data.items.forEach(function(item){
                            newOptions.push({label:item.name,value:item.id})
                        })
                        return newOptions
                    })
            )
        })
    }

    const loadCollections=()=>{
        return new Promise(function(resolve){
            resolve(
                requestApi("collections/list",{})
                    .then(data=>{
                        let newOptions=[]
                        data.items.forEach(function(item){
                            newOptions.push({label:item.name,value:item.id})
                        })
                        return newOptions
                    })
            )
        })
    }

    const loadData=()=>{
        return new Promise(function(resolve){
            if(mode=="edit"){
                resolve(
                    requestApi("models/generated_info",{
                            reference:params.reference
                        })
                        .then(data=>{
                            return data.data
                        })
                )
            }else{
                resolve(
                    ()=>{return ""}
                )
            }
        })
    }

    useEffect(()=>{
        load()
    },[params.reference])

    const load=()=>{
        Promise.all([loadModels,loadCollections,loadData].map(func=>func())).then((result)=>{
            setModelOptions(result[0])
            setCollectionOptions(result[1])
            setDefaultData(result[2])
            setReady(1)
        })
    }

    useEffect(()=>{
        modelOptions.forEach(function(item){
            if(item.value==params.reference){
                modelInput.current.setValue({label:item.label,value:item.value})
            }
        })
    },[modelOptions])

    useEffect(()=>{
        if(mode=="edit" && ready){
            setIdVal(defaultData.id)
            setNameVal(defaultData.name)
            modelOptions.forEach(function(item){
                if(item.value==defaultData.model){
                    modelInput.current.setValue({label:item.label,value:item.value})
                }
            })
            collectionOptions.forEach(function(item){
                if(item.value==defaultData.collection){
                    collectionInput.current.setValue({label:item.label,value:item.value})
                }
            })
        }else{
            setNameVal("")
            setModelVal("")
            setCollectionVal("")
        }
    },[defaultData])

    const saveData=()=>{
        if(nameVal==""){
            nameInput.current.focus()
        }else{
            if(modelInput.current.getValue().length==0){
                modelInput.current.focus()
            }else{
                if(collectionInput.current.getValue().length==0){
                    collectionInput.current.focus()
                }else{
                    requestApi("models/generated_save",{
                            id:idVal,
                            mode:mode,
                            name:nameVal,
                            model:modelInput.current.getValue()[0]?modelInput.current.getValue()[0].value:0,
                            collection:collectionInput.current.getValue()[0]?collectionInput.current.getValue()[0].value:0
                        })
                        .then(data=>{
                            if(data.status=="success"){
                                if(mode=="create"){
                                    changeToast("created_m","")
                                }else if(mode=="edit"){
                                    changeToast("saved","")
                                }
                                refresh({board:"models",close:"models-generate"})
                                loadBoard({params:{alias:"models-edit",level:2,theme:"rabbit",reference:params.reference,mode:"edit"}})
                            }else{
                                changeDialog("generic_error","","")
                            }
                        })
                }
            }
        }
    }

    const remove=()=>{
        requestApi("models/generated_remove",{
                reference:idVal
            })
            .then(data=>{
                if(data.status=="success"){
                    changeToast("removed","")
                    refresh({board:"models",close:"models-generated"})
                }else{
                    changeToast("generic_error","")
                }
            })
    }

    return(
        <Board params={params} ready={ready}>
            <BoardActions
                actionsLeft={<ButtonCircle icon="back" style="alt" clickEvent={()=>{loadBoard({params:{alias:"models-edit",level:2,theme:"rabbit",mode:"edit",reference:params.reference}})}} />}
                actionsRight={<ButtonAction label="Guardar" icon="wink" clickEvent={saveData} />} />
            <BoardContent>
                <div className="board-form">
                    <Textbox ref={nameInput} type="text" label="Nombre" val={nameVal} setVal={setNameVal} disabled={false} />
                    <Divisor />
                    <Selector ref={modelInput} options={modelOptions} label="Modelo" placeholder="" multiple={false} searchable={true} style="field" val={modelVal} setVal={setModelVal} />
                    <Selector ref={collectionInput} options={collectionOptions} label="Grupo" placeholder="" multiple={false} searchable={true} style="field" val={collectionVal} setVal={setCollectionVal} />
                    {mode=="edit" &&
                    <div className="commands-block">
                        <ButtonCommand label="Eliminar" icon="remove" clickEvent={remove} />
                    </div>}
                </div>
            </BoardContent>
        </Board>
    )
}